import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

const iconBoxVariants = cva("flex items-center justify-center", {
  variants: {
    size: {
      sm: "w-10 h-10",
      md: "w-16 h-16",
      lg: "w-20 h-20",
    },
    variant: {
      default: "bg-secondary border border-border",
      muted: "bg-secondary/50 border border-border",
      gradient:
        "bg-gradient-to-br from-brand to-brand-secondary shadow-lg shadow-brand/30",
    },
    rounded: {
      lg: "rounded-lg",
      xl: "rounded-xl",
      "2xl": "rounded-2xl",
      full: "rounded-full",
    },
  },
  defaultVariants: {
    size: "md",
    variant: "default",
    rounded: "2xl",
  },
});

interface IconBoxProps extends VariantProps<typeof iconBoxVariants> {
  className?: string;
  children: ReactNode;
}

export function IconBox({
  size,
  variant,
  rounded,
  className,
  children,
}: IconBoxProps) {
  return (
    <div className={cn(iconBoxVariants({ size, variant, rounded }), className)}>
      {children}
    </div>
  );
}
